// The family-logistics gate as the browser sees it. The server's switch is
// JANET_FAMILY_LOGISTICS_ENABLED (api/_lib/janet-family-gate.js); the app's is
// VITE_JANET_FAMILY_LOGISTICS_ENABLED — plain project config, never Sensitive
// (a Sensitive VITE_ var reaches the prebuilt bundle as a placeholder). Both
// default off, so Home and Janet's chat show only work items until both are on.
export function familyEnabledInBrowser(env = import.meta.env) {
  return env?.VITE_JANET_FAMILY_LOGISTICS_ENABLED === 'true'
}
